import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-work-layout',
  templateUrl: './work-layout.component.html',
  encapsulation: ViewEncapsulation.None
})
export class WorkLayoutComponent {}
